import _MeteorWallet from "./MeteorWallet";
import _MeteorSdkUtils from "./utils/MeteorSdkUtils";
import _MeteorWalletConstants from "./MeteorWalletConstants";
import _types_dappConnect from "../../meteor-common/src/modules_feature/dapp_connect/types_dappConnect";
import _near_basic_types from "../../meteor-common/src/modules_external/near/types/near_basic_types";
import _envConfig from "./envConfig";
var exports = {};
var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = exports && exports.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEnvConfig = exports.ENearNetwork = void 0;
__exportStar(_MeteorWallet, exports);
__exportStar(_MeteorSdkUtils, exports);
__exportStar(_MeteorWalletConstants, exports);
__exportStar(_types_dappConnect, exports);
var near_basic_types_1 = _near_basic_types;
Object.defineProperty(exports, "ENearNetwork", {
  enumerable: true,
  get: function () {
    return near_basic_types_1.ENearNetwork;
  }
});
var envConfig_1 = _envConfig;
Object.defineProperty(exports, "setEnvConfig", {
  enumerable: true,
  get: function () {
    return envConfig_1.setEnvConfig;
  }
});
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  setEnvConfig = exports.setEnvConfig,
  ENearNetwork = exports.ENearNetwork,
  ConnectedMeteorWalletAccount = exports.ConnectedMeteorWalletAccount,
  MeteorWallet = exports.MeteorWallet,
  getNetworkPreset = exports.getNetworkPreset,
  resolveWalletUrl = exports.resolveWalletUrl,
  WALLET_URL_LOCALHOST_BASE = exports.WALLET_URL_LOCALHOST_BASE,
  WALLET_URL_PRODUCTION_BASE = exports.WALLET_URL_PRODUCTION_BASE,
  WALLET_URL_DEV_BASE = exports.WALLET_URL_DEV_BASE,
  EDappActionConnectionStatus = exports.EDappActionConnectionStatus,
  EDappActionSource = exports.EDappActionSource,
  EMeteorInjectedFeature = exports.EMeteorInjectedFeature,
  EMeteorExtensionDirectActionType = exports.EMeteorExtensionDirectActionType,
  EWalletExternalActionStatus = exports.EWalletExternalActionStatus,
  EWalletExternalAction_SignIn_AccessType = exports.EWalletExternalAction_SignIn_AccessType,
  EMeteorWalletSignInType = exports.EMeteorWalletSignInType,
  EExternalActionType = exports.EExternalActionType,
  MeteorActionError = exports.MeteorActionError;